import { render, staticRenderFns } from "./insumos.vue?vue&type=template&id=04b35f53&scoped=true&"
import script from "./insumos.vue?vue&type=script&lang=js&"
export * from "./insumos.vue?vue&type=script&lang=js&"
import style0 from "./insumos.vue?vue&type=style&index=0&id=04b35f53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b35f53",
  null
  
)

export default component.exports